<form #newModule (ngSubmit)="submit()" class="mt-4 mb-0">  

    <div class="fieldset fieldset--lg">
      <label class="legend" for="link">Vcircle Media Link <span class="requiredfield">*</span></label>
      <input type="url" name="medialink" id="medialink" class="text-field" [(ngModel)]="mediaLink" required="required">
    </div>
    <div class="fieldset fieldset--lg">
      <label class="legend" for="title">Title <span class="requiredfield">*</span></label>
      <input type="text" name="title" id="title" class="text-field" [(ngModel)]="mediaTitle" required="required">
    </div>
    <div class="d-flex justify-content-center flex-wrap gap-1.5">
      <button *ngIf="uploading; else notUploading" type="button" class="btn btn--loading m-0">redirecting in {{countdown}}</button>
      <ng-template #notUploading>
        <button [disabled]="this.mediaTitle.length <= 0 || this.mediaLink.length <= 0" type="submit" class="btn m-0">Upload</button>
      </ng-template>
    </div>
  </form>
  